/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Chargers Fault properties that can be used for sorting. Default value is 'timestamp'.
 *
 */
export var ChargerFaultPropertiesForSorting;
(function (ChargerFaultPropertiesForSorting) {
    ChargerFaultPropertiesForSorting["ERROR_CODE"] = "errorCode";
    ChargerFaultPropertiesForSorting["ERROR_INFO"] = "errorInfo";
    ChargerFaultPropertiesForSorting["CONNECTOR_ID"] = "connectorId";
    ChargerFaultPropertiesForSorting["VENDOR"] = "vendor";
    ChargerFaultPropertiesForSorting["VENDOR_ERROR_CODE"] = "vendorErrorCode";
    ChargerFaultPropertiesForSorting["VENDOR_ERROR_DESCRIPTION"] = "vendorErrorDescription";
    ChargerFaultPropertiesForSorting["TIMESTAMP"] = "timestamp";
})(ChargerFaultPropertiesForSorting || (ChargerFaultPropertiesForSorting = {}));
